module.exports = __webpack_public_path__ + "img/icon_2_5.183c462f.png";